import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { tap, withLatestFrom } from 'rxjs/operators';

import { State } from '@app/app.reducer';
import { getAccessToken } from '@app/auth/auth.reducer';
import { AuthService } from '@app/core/auth.service';
import {
  registerInit,
  registerBasicInfoSuccess,
  registerReset,
} from '@app/registration/consumer/consumer-registration.actions';

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions, private store: Store<State>, private authService: AuthService) {}

  register$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(registerBasicInfoSuccess, registerInit),
        withLatestFrom(this.store.pipe(select(getAccessToken))),
        tap(([_action, token]) => {
          if (token) {
            this.authService.setToken(token);
          }
        }),
      ),
    { dispatch: false },
  );

  registerReset$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(registerReset),
        tap(() => {
          this.authService.logout('/register');
        }),
      ),
    { dispatch: false },
  );
}
